export const BLUE_COLOR = "#00b7cd";
export const DARKBLUE_COLOR = "#003086";
export const PINK_COLOR = "#d90b7c";
export const LIGHTGRAY_COLOR = "#e7edf3";
export const LIGHTGREEN_COLOR = "#8dc100";
export const DARKGREEN_COLOR = "#00a89d";
export const ORANGE_COLOR = "#ffc659";
export const RED_COLOR = "#d0021b";
export const MODIFIEDBLACK = "#3b4045";
export const PROTECT_GREEN = '#a7b93a'
export const VIBRANT_GREEN = '#3dcd58';
export const ALTERNATEROW_BACKGROUND_COLOR = 'rgba(250,250,250,1.0)';

export const AUTH = 'auth';
